module.exports = __webpack_public_path__ + "media/images/warning-icon-462747942807857761b4967cdd8e10ae.svg";